import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { currencyFormatNew } from "../pdpComponents/utils.jsx";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import "react-tooltip/dist/react-tooltip.css";
import { getCMS, getUserAction, isUserAuthorised } from "@/api/PDP";
import { isValidSession } from "@/api/auth";
import { isPhoneNoVerified } from "@/api/bid";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import { setIsOtpVerificationModalRequired } from "@/redux/login/loginSlice";
import { sendVerificationCode } from "@/api/LoginSignup";
import { showOtpModal } from "@/redux/otpModal/otpModalSlice";
import LoadingText from "@/components/loader/LoadingText.jsx";
import LoadedText from "@/components/loader/LoadedText.jsx";
import { enableOwnItNow, setOfferData, setPdpError, setRedirectionAction, setRedirectionAmount, setSelectedBidAmount } from "@/redux/PDP/pdpSlice";
import NDAModel from "./NDAModel.jsx";
import { getUserProfile } from "@/api/myProfile.js";
import { setProfileInfo } from "@/redux/user/userSlice.js";
import BidAlertTextModal from "./BidAlertTextModal.jsx";
import { trackApiCall, trackButtonClick } from "@/utils/analytics.js";

const BidCenterHeader = ({
  statusPayload,
  navigation,
  pdpBidCenter,
  pdpData,
  listingType,
  status,
  offerType,
  offerCenterDetail,
  isSignedUser,
  isFcOnlineFlag,
  isWatchProperty,
  timeLeft,
  timeLeftUnit,
  isLastFewMins,
  priceLabel,
  priceAmount
}) => {
  const {
    isUnderReview,
    isPreview,
    isUnderContractAuction,
    isUnderContractTraditional,
    isHNBTraditional,
    isShortSaleUnderContractAuction,
    isShortSaleUnderContractTraditional,
    isUnderReviewAuction,
    isShortSaleUnderReview,
  } = statusPayload;

  const { propertyId, detailedAttributes, commonAttributes } =
    pdpData?.propertyDetails || {};

  const latestBidCenterData = useSelector(
    (state) => state.pdp?.latestBidCenterData
  );

  const currentSavedProperties = useSelector((state) => state.saved?.savedProperties);
  const userData = useSelector((state) => state.auth?.registration);
  const onWatchList = useSelector((state) => state.pdp?.onWatchList);
  const user = useSelector((state) => state.user);
  const [isSaved, setIsSaved] = useState(onWatchList);
  const [isVerificationGoing, setIsVerificationGoing] = useState(false)
  const [isVerificationGoingForOwnitNow, setIsVerificationGoingForOwnitNow] = useState(false)
  const { propCategory } = commonAttributes || {};
  const { isPrelistAsset, apnTaxId, isAllowedPreSale } = detailedAttributes || {};
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [showOfferAlert, setShowOfferAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const ownItNowEnabled = pdpInitData?.listingDetail?.ownItNowFlag;
  const [showDynamicBiddingPopUp, setShowDynamicBiddingPopUp] = useState(false);
  const [showBestBidModal, setShowBestBidModal] = useState(false);
  const profileInfo = useSelector((state) => state.user.user);
    const isNDAAccepted = useSelector((state) => state.pdp.isNDAAccepted);
  const [showNDA, setShowNDA] = useState(false);
  const navigate = useNavigate();
 const auctionDetails = useSelector((state) => state.pdp.auctionDetails);
  const isFcOnlineProp =
    isFcOnlineFlag != undefined && isFcOnlineFlag === "Y" ? true : false;
  const bidCenterData = useSelector((state) => state.pdp.bidCenterData);
  const redirectionAmount = useSelector((state) => state.pdp?.redirectionAmount);

  const bestBidAvailable =
    bidCenterData.bestBidAvailable && isSignedUser ? true : false;
  const undercontractOffer = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };

  const underReviewData = {
    header: pdpBidCenter?.underreview,
    content: pdpBidCenter?.underreviewdesc,
  };
  const previewData = {
    header: pdpBidCenter?.previewPropertyContent?.previewPropertyHeader,
    content: pdpBidCenter?.previewPropertyContent?.previewPropertyContent,
  };
  const underContractAuctionData = {
    header: pdpBidCenter?.undercontractAuction,
    content: pdpBidCenter?.undercontractdesc,
  };
  const underContractTraditionalData = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };
  const hNBTraditionalData = {
    header: pdpBidCenter?.hnbended,
    content: pdpBidCenter?.undercontractofferhnbdesc,
  };
  const shortSaleUnderContractTraditionalData = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };
  const hasHnbData = {
    header: pdpBidCenter?.hnbended,
    content: pdpBidCenter?.undercontractofferhnbdesc,
  };
  const isShortSaleUnderContractAuctionData = {
    content: pdpBidCenter?.undercontractdescShortSale,
  };

  const fcOnlineAuctionEventEnded = {
    header: pdpBidCenter?.pdpFcOnline?.auctionEventEnded,
    content: pdpBidCenter?.pdpFcOnline?.auctionEventEndedSubTxt,
  };

  let hnbDeadlnDt = [];
  let higherstBidTerms = {};
  let date = `${hnbDeadlnDt[1]} ${hnbDeadlnDt[2]} on ${hnbDeadlnDt[0]}`;
  if (statusPayload?.hnbDeadlnDt) {
    hnbDeadlnDt = statusPayload.hnbDeadlnDt.split(" ");
    higherstBidTerms = {
      header: pdpBidCenter?.hnbrequestedtitle,
      content: pdpBidCenter?.hnbdesc?.replace("###DATE###", date),
    };
  }
  const [bidIncrementCount, setBidIncrementCount] = useState(Number(0));
  const [bidAmount, setBidAmount] = useState(
  auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
      latestBidCenterData?.nextpossibleBidAmount &&
      Number(auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount)
  );

  // const [offerAmount, setOfferAmount] = useState(redirectionAmount ? redirectionAmount : "");
  const [validationError, setvalidationError] = useState("");
  const [cmsErrorMessages, setCmsErrorMessages] = useState();
  const [bidActionType, setBidActionType] = useState("")

  const [activeConfigData, setActiveConfigData] = useState([]);
        const [isNDAAcceptedLocal, setIsNDAAcceptedLocal] = useState(isNDAAccepted);


  let nextpossibleBidAmount = 0;
  let biddingIncrementalAmount = 0;
  let incrementMultiplier = 0;
  let maximumPossibleBidAmount = 0;
  let bidMinLimit = 0;
  let bidMaxLimit = 0;
  let bidMaxLength = 0;
  let lowerThresholdAmount = 0;
  let lowerThresholdIncrementMultiplier = 0;
  let upperThresholdAmount = 0;
  let upperThresholdIncrementMultiplier = 0;
  let offerMinLimit = 0;
  let offerMaxLimit = 0;
  let customBidIncrementMultiplier = 0;

  if (bidCenterData) {
    biddingIncrementalAmount = bidCenterData?.biddingIncrementalAmount;
    customBidIncrementMultiplier = bidCenterData?.customBidIncrementMultiplier;
    incrementMultiplier = bidCenterData?.incrementMultiplier;
    maximumPossibleBidAmount = bidCenterData?.maximumPossibleBidAmount;
    nextpossibleBidAmount =  auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount : latestBidCenterData.nextpossibleBidAmount;
    lowerThresholdAmount = bidCenterData?.lowerThresholdAmount;
    upperThresholdAmount = bidCenterData?.upperThresholdAmount;
    lowerThresholdIncrementMultiplier =
      bidCenterData?.lowerThresholdIncrementMultiplier;
    upperThresholdIncrementMultiplier =
      bidCenterData.upperThresholdIncrementMultiplier;


      if (
       latestBidCenterData?.highestBidAmount  >= upperThresholdAmount &&
      bidCenterData?.activeBidRefinementEnabled === true
    ) {
      bidMinLimit =
        latestBidCenterData?.highestBidAmount + upperThresholdIncrementMultiplier;
      bidMaxLimit = latestBidCenterData?.highestBidAmount + upperThresholdIncrementMultiplier;
    } else if (
       latestBidCenterData?.highestBidAmount  >= lowerThresholdAmount &&
      latestBidCenterData?.activeBidRefinementEnabled === true
    ) {
      bidMinLimit =
         latestBidCenterData?.highestBidAmount  + lowerThresholdIncrementMultiplier;

     bidMaxLimit = latestBidCenterData?.highestBidAmount + 2*(lowerThresholdIncrementMultiplier);

    } else if (
      auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount &&
          auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount > 0
    ) {
      bidMinLimit = auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount;
     bidMaxLimit = bidCenterData?.maximumPossibleBidAmount;


    } else {
      bidMinLimit = latestBidCenterData?.highestBidAmount + biddingIncrementalAmount;
       bidMaxLimit = bidCenterData?.maximumPossibleBidAmount;

    }

     if( latestBidCenterData?.activeBidRefinementEnabled === true && nextpossibleBidAmount <= lowerThresholdAmount){
              bidMaxLimit = lowerThresholdAmount;
    }


    // if (
    //   bidCenterData?.maximumPossibleBidAmount &&
    //   bidCenterData?.maximumPossibleBidAmount > 0
    // ) {
    //   bidMaxLimit =
    //     bidCenterData?.activeBidRefinementEnabled === true &&
    //       nextpossibleBidAmount <= lowerThresholdAmount
    //       ? lowerThresholdAmount
    //       : bidCenterData?.maximumPossibleBidAmount;
    // }
  }

  bidMaxLength = (bidMaxLimit + " ").length + 1;
  if (pdpInitData && pdpInitData.offerCenterDetail) {
    offerMinLimit = pdpInitData.offerCenterDetail.minimumStartingOffer;
    offerMaxLimit = pdpInitData.offerCenterDetail.maximumPermissibleOffer;
  }

  const lowerSlab =
    lowerThresholdAmount > bidCenterData?.currentHighestBid
      ? lowerThresholdAmount
      : bidCenterData?.currentHighestBid + lowerThresholdIncrementMultiplier;

  const upperSlab =
   upperThresholdAmount >= auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
      latestBidCenterData?.nextpossibleBidAmount
        ? upperThresholdAmount
        : auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount;

  const [lowerSlabAmount, setLowerSlabAmount] = useState("");
  const [upperSlabAmount, setUpperSlabAmount] = useState("");
  const [slabUpdated, setSlabUpdated] = useState(false);


  if (slabUpdated != true) {
    setLowerSlabAmount(lowerSlab || "");
    setUpperSlabAmount(upperSlab || "");
    setSlabUpdated(true);
  }


customBidIncrementMultiplier = incrementMultiplier;

  const dispatch = useDispatch();

  // Read CMS data from Redux store (already fetched at app init) instead of
  // making duplicate API calls on every mount.
  const globalCmsResults = useSelector(
    (state) => state.cms?.data?.global?.results?.[0]
  );

  useEffect(() => {
    if (globalCmsResults) {
      if (globalCmsResults?.appUpdateConfig?.activeBidConfig) {
        setActiveConfigData(globalCmsResults.appUpdateConfig.activeBidConfig);
      }
      if (!cmsErrorMessages && globalCmsResults?.errorMessages) {
        setCmsErrorMessages(globalCmsResults.errorMessages);
      }
    } else {
      // Fallback: fetch from API only if Redux store doesn't have it yet
      getCMS(encodeURI("global/appUpdateConfig/activeBidConfig")).then(
        (response) => {
          setActiveConfigData(response?.results);
        }
      );
      if (!cmsErrorMessages) {
        getCMS("global/errorMessages").then((response) => {
          setCmsErrorMessages(response?.results?.[0]);
        });
      }
    }
  }, [globalCmsResults]);
  let errorMessage = null;

  const validateBidMinMaxPriceError = () => {

    const CHB = nextpossibleBidAmount - biddingIncrementalAmount;
    if ((parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier != 0) {

      if (bidCenterData?.activeBidRefinementEnabled === true &&
        parseInt(bidAmount) === lowerThresholdAmount) {

      } else {

        if (bidCenterData?.activeBidRefinementEnabled === true &&
          bidCenterData?.currentHighestBid < lowerThresholdAmount &&
          parseInt(bidAmount) > lowerThresholdAmount) {

          errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
            "###MAX_BID_AMOUNT###",
            getFormatPrice(bidMaxLimit)
          );
          setvalidationError(
            errorMessage
          );
          dispatch(setPdpError(errorMessage))

        } else {

          errorMessage =
            "Please use $" +
            currencyFormatNew(customBidIncrementMultiplier) +
            " increments";
          setvalidationError(
            "Please use $" +
            currencyFormatNew(customBidIncrementMultiplier) +
            " increments"
          );
            dispatch(setPdpError( "Please use $" +
            currencyFormatNew(customBidIncrementMultiplier) +
            " increments"))


        }

      }

    } else if (bidAmount === 0 || bidAmount === "" || bidAmount === "$") {
      setvalidationError(cmsErrorMessages?.EMPTY_BID_AMOUNT);
      dispatch(setPdpError( cmsErrorMessages?.EMPTY_BID_AMOUNT))
      errorMessage = cmsErrorMessages?.EMPTY_BID_AMOUNT;
    } else if (Number(bidAmount) < bidMinLimit) {
      setvalidationError(
        cmsErrorMessages?.MIN_BID_AMOUNT.replace(
          "###MIN_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MIN_BID_AMOUNT.replace(
          "###MIN_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )))
      errorMessage = cmsErrorMessages?.MIN_BID_AMOUNT.replace(
        "###MIN_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      );
    }
    // else if (
    //   Number(bidAmount) > bidMaxLimit &&
    //   bidCenterData?.activeBidRefinementEnabled !== true  ////changed as part of 110 bidwizard sheer
    // ) {
    else if (
      Number(bidAmount) > bidMaxLimit
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMaxLimit)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMaxLimit)
        )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMaxLimit)
      );
      return;
    } else if (Number(bidAmount) > maximumPossibleBidAmount) {
      setvalidationError(cmsErrorMessages?.MAX_BID_REACHED);
       dispatch(setPdpError(cmsErrorMessages?.MAX_BID_REACHED))
      errorMessage = cmsErrorMessages?.MAX_BID_REACHED;
    } else {
      setvalidationError("");
       dispatch(setPdpError(""))
      errorMessage = null;
    }

    if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      bidCenterData?.currentHighestBid >= lowerThresholdAmount &&
      latestBidCenterData?.nextpossibleBidAmount < upperThresholdAmount &&
      bidAmount > bidMinLimit + lowerThresholdIncrementMultiplier
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
        )
      );
       dispatch(setPdpError(cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
        )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
      );
    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      bidCenterData?.currentHighestBid >= upperThresholdAmount &&
      bidAmount > bidMinLimit + upperThresholdIncrementMultiplier
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )
      );
       dispatch(setPdpError( cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      );
    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >=
      parseInt(
        lowerThresholdAmount +
        (nextpossibleBidAmount % biddingIncrementalAmount) +
        biddingIncrementalAmount
      ) &&
      nextpossibleBidAmount <=
      lowerThresholdAmount +
      (nextpossibleBidAmount % biddingIncrementalAmount)
    ) {
      /* bid amount in the border of lower threshhold  added equal to for HUBZ-3027*/
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        )
      );
      dispatch(setPdpError( "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        )))
      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        );

    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >
      parseInt(
        upperThresholdAmount +
        (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
      ) &&
      nextpossibleBidAmount <
      upperThresholdAmount +
      (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
    ) {
      /* bid amount in the border of upper threshhold */
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        )
      );
      dispatch(setPdpError(  "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        )))

      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        );
    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >
      parseInt(upperSlab - upperThresholdIncrementMultiplier) +
      parseInt(upperThresholdIncrementMultiplier) *
      activeConfigData?.upperThreshHoldMaxCount
    ) {
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab - upperThresholdIncrementMultiplier) +
          parseInt(upperThresholdIncrementMultiplier) *
          activeConfigData?.upperThreshHoldMaxCount
        )
      );
        dispatch(setPdpError(  "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab - upperThresholdIncrementMultiplier) +
          parseInt(upperThresholdIncrementMultiplier) *
          activeConfigData?.upperThreshHoldMaxCount
        )))

      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        );

      // setBidAmountError(true);

    }


  };

  const getFormatPrice = (amnt) => {
    if (amnt?.length === 0 || isNaN(amnt)) {
      return "";
    }
    return amnt?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };

  const getFormattedPrice = (amount) => {
    return getFormatPrice(amount ? amount : bidAmount);
  };

  const decrement = () => {
    setvalidationError("");
     dispatch(setPdpError(""))

    if (bidAmount > bidMinLimit) {
      trackButtonClick({
        eventName: "bid_center_decrement_click",
        eventCategory: "NEW-PDP",
        eventSource: "on decrement button click",
        eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Decrement`
      })

      if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        bidCenterData?.currentHighestBid >= lowerThresholdAmount &&
        bidCenterData?.currentHighestBid < upperThresholdAmount
      ) {

        if (bidAmount > bidMaxLimit) {
          setBidAmount(parseInt(nextpossibleBidAmount));
        } else {

          const CHB = nextpossibleBidAmount - lowerThresholdIncrementMultiplier;

          const remainder =
            (parseInt(bidAmount) - parseInt(CHB)) % parseInt(lowerThresholdIncrementMultiplier);

          if (remainder === 0) {
            setBidAmount(
              parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier)
            );
          } else {
            setBidAmount(parseInt(bidAmount) - remainder);

          }
          // setBidAmount(
          //   parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier)
          // );
          setBidIncrementCount(bidIncrementCount - 1);

        }


      } else if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        bidCenterData?.currentHighestBid >= upperThresholdAmount
      ) {

        const CHB = nextpossibleBidAmount - upperThresholdIncrementMultiplier;


        const remainder =
          (parseInt(bidAmount) - parseInt(CHB)) % parseInt(upperThresholdIncrementMultiplier);

        if (remainder === 0) {
          setBidAmount(
            parseInt(bidAmount) - parseInt(upperThresholdIncrementMultiplier)
          );
        } else {
          setBidAmount(parseInt(bidAmount) - remainder);

        }
        // setBidAmount(bidAmount - upperThresholdIncrementMultiplier);
        setBidIncrementCount(bidIncrementCount - 1);
      } else {
        const CHB = nextpossibleBidAmount - biddingIncrementalAmount;

        if ((parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier != 0) {
          const remainder = (parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier;
          setBidAmount(parseInt(bidAmount) - remainder);
        }
        else if (bidAmount > bidMaxLimit) {
          setBidAmount(parseInt(nextpossibleBidAmount));
        } else {
          setBidAmount(parseInt(bidAmount) - parseInt(biddingIncrementalAmount));
        }
        // setBidAmount(bidAmount - biddingIncrementalAmount);
      }
    } else {
      setBidAmount(parseInt(nextpossibleBidAmount));
      // validateBidMinMaxPriceError();
    }
  };

  const increment = () => {
    setvalidationError("");
    dispatch(setPdpError(""))
    if (bidAmount < bidMaxLimit) {
      trackButtonClick({
        eventName: "bid_center_increment_click",
        eventCategory: "NEW-PDP",
        eventSource: "on increment button click",
        eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Increment`
      })

      if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) >= lowerThresholdAmount &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) < upperThresholdAmount
      ) {
        if (bidAmount < bidMinLimit + lowerThresholdIncrementMultiplier) {
          if (bidAmount < bidMinLimit) {
            setBidAmount(bidMinLimit);

          } else {


            const CHB = nextpossibleBidAmount - lowerThresholdIncrementMultiplier;

          const remainder =
            (parseInt(bidAmount) - parseInt(CHB)) %
            lowerThresholdIncrementMultiplier;
          const adjustment = lowerThresholdIncrementMultiplier - remainder;
          setBidAmount(parseInt(bidAmount) + adjustment);



            // setBidAmount(
            //   parseInt(bidAmount) + parseInt(lowerThresholdIncrementMultiplier)
            // );
             setBidIncrementCount(bidIncrementCount + 1);
          }

        } else {
          validateBidMinMaxPriceError();
        }
      } else if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) >= upperThresholdAmount
      ) {
        if (
          bidIncrementCount < 0 &&
       (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
            latestBidCenterData?.nextpossibleBidAmount) > upperThresholdAmount
        ) {


           const CHB = nextpossibleBidAmount - upperThresholdIncrementMultiplier;

          const remainder =
                (parseInt(bidAmount) - parseInt(CHB)) %
                upperThresholdIncrementMultiplier;
              const adjustment = upperThresholdIncrementMultiplier - remainder;
              setBidAmount(parseInt(bidAmount) + adjustment);

          // setBidAmount(bidAmount + upperThresholdIncrementMultiplier);
           setBidIncrementCount(bidIncrementCount + 1);
        } else {
          validateBidMinMaxPriceError();
        }
      } else {
         if (
          bidCenterData?.activeBidRefinementEnabled === true &&
          parseInt(bidAmount) + parseInt(biddingIncrementalAmount) >
            lowerThresholdAmount
        ) {
          validateBidMinMaxPriceError();
        } else {
          if (bidAmount < bidMinLimit) {
            setBidAmount(parseInt(bidMinLimit));
          } else {
            const CHB = nextpossibleBidAmount - biddingIncrementalAmount;

            if (
              (parseInt(bidAmount) - parseInt(CHB)) %
                customBidIncrementMultiplier !=
              0
            ) {
              const remainder =
                (parseInt(bidAmount) - parseInt(CHB)) %
                customBidIncrementMultiplier;
              const adjustment = customBidIncrementMultiplier - remainder;
              setBidAmount(parseInt(bidAmount) + adjustment);
            } else {
              if (parseInt(bidAmount) < bidMinLimit) {
                setBidAmount(bidMinLimit);
                amount = bidMinLimit;
              } else {

                  const remainder =
                (parseInt(bidAmount) - parseInt(CHB)) %
                biddingIncrementalAmount;
              const adjustment = biddingIncrementalAmount - remainder;
              setBidAmount(parseInt(bidAmount) + adjustment);

              //   setBidAmount(
              //     parseInt(bidAmount) + parseInt(biddingIncrementalAmount)
              //   );
              //   amount =
              //     parseInt(bidAmount) + parseInt(biddingIncrementalAmount);
               }
            }
          }
        }

      //   const CHB = nextpossibleBidAmount - biddingIncrementalAmount;

      //   if ((parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier != 0) {
      //     const remainder = (parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier;
      //     const adjustment = customBidIncrementMultiplier - remainder;
      //     setBidAmount(parseInt(bidAmount) + adjustment);

      //   } else {

      //     if (parseInt(bidAmount) < bidMinLimit) {
      //       setBidAmount(bidMinLimit)

      //     } else {
      //       setBidAmount(parseInt(bidAmount) + parseInt(biddingIncrementalAmount));
      //     }

      //   }
       }
    } else {
      validateBidMinMaxPriceError();
    }
  };

  const handleOwnItNow = async () => {
    validateBidMinMaxPriceError();
    setIsVerificationGoingForOwnitNow(true);

    try {
      if (profileInfo?.userEmailId) {
        const isSessionValid = await isValidSession();
        const isValid = isSessionValid.data?.isValidSession;

        const phoneNo = profileInfo?.primaryPhone;

        if (isValid === "Y") {

          trackButtonClick({
            eventName: "own_it_now_aucn",
            eventCategory: "NEW-PDP",
            eventSource: "on own it now click",
            eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Own it now- AUCN`,
          });

          const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
          setIsVerificationGoingForOwnitNow(false);

          if (res?.data?.data) {
            dispatch(enableOwnItNow(true));
            if (!(validationError?.length > 0)) {
              trackButtonClick({
                eventName: "user_action_type_check",
                eventCategory: "NEW-PDP",
                eventSource: "on own it now click",
                eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`
              })

              const isAuthorised = await isUserAuthorised(pdpInitData?.propertyDetails?.listingId);

              trackApiCall({
                eventName: "user_action_type_check_success",
                eventCategory: "NEW-PDP",
                eventSource: "on own it now click",
                eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`,
                eventParams: { success: true }
              })

              if (isAuthorised.message === 'USER_NOT_ALLOWED_TO_BID') {
                setAlertText("You cannot place another bid as you are the current highest bidder.")
                setShowAlert(true);

              } else {
                dispatch(setSelectedBidAmount(bidAmount));
                // navigate("/bid");
                if (propCategory === 'COMMERCIAL' && isNDAAccepted === 'N') {
                  setShowNDA(true);
                } else {
                  navigate("/bid");
                }
              }

            }
          } else {
            const isPhoneVerified = res?.data?.data;

            const data = { phoneNo, verificationType: "sms" }
            if (!isPhoneVerified) {
              dispatch(
                showOtpModal({
                  phoneNumber: profileInfo?.primaryPhone,
                  redirectScreen: "PDP",
                })
              );
              dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
              const response = await sendVerificationCode(data);

              if (
                response?.status === "FAILURE" &&
                response?.errorCode.startsWith("Invalid")
              ) {
              }
            }
          }
        } else {
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
        }
      } else {
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
        dispatch(setShowSessionMsg(false))
      }
    } catch (error) {
    } finally {
      setIsVerificationGoingForOwnitNow(false);
    }
  };


  const hanldePlaceBid = async (type) => {
  if(latestBidCenterData.placeBackupBidButton !== true ){
       validateBidMinMaxPriceError();
    }
      // validateBidMinMaxPriceError();
    setBidActionType(type)
    setIsVerificationGoing(true);
    try {
      if (profileInfo?.userEmailId) {
        const isSessionValid = await isValidSession();
        const isValid = isSessionValid.data?.isValidSession;
        if (isValid === "Y") {
          trackButtonClick({
            eventName: "place_bid_action",
            eventParams: { action_type: type },
            eventCategory: "NEW-PDP",
            eventSource:
              type === "placeBid"
                ? "on place bid click"
                : type === "placeBackupBid"
                ? "on place backup bid click"
                : type === "registerToBid"
                ? "on register to bid click"
                : type === "registerCompleted"
                ? "on register completed click"
                : "on place bid click",
            eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | ${
              type === "placeBid"
                ? "Place Bid"
                : type === "placeBackupBid"
                ? "Place Backup Bid"
                : type === "registerToBid"
                ? "Register To Bid"
                : type === "registerCompleted"
                ? "Register Completed Preview"
                : "Place Bid"
            }`,
          });

          // ⚠️ Do not remove, this is requried to pass updated data to otp verification screen
          getUserProfile().then((response) => {
            const data = response?.data;
            dispatch(setProfileInfo(data));
          });
          const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
          setIsVerificationGoing(false);
          dispatch(enableOwnItNow(false));
          if (res?.data?.data) {
            if (!(validationError?.length > 0)) {
              trackButtonClick({
                eventName: "user_action_type_check",
                eventCategory: "NEW-PDP",
                eventSource: "on place bid click",
                eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`
              })

              const isAuthorised = await isUserAuthorised(
                pdpInitData?.propertyDetails?.listingId
              );

              trackApiCall({
                eventName: "user_action_type_check_success",
                eventCategory: "NEW-PDP",
                eventSource: "on place bid click",
                eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId} | Place Bid`,
                eventParams: { success: true }
              })

              if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
                setAlertText(
                  "You cannot place another bid as you are the current highest bidder."
                );
                setShowAlert(true);
              } else {
                dispatch(setSelectedBidAmount(bidAmount));
                if (propCategory === "COMMERCIAL" && status !== "PACT") {
                  if (isNDAAccepted === "N" || isNDAAccepted === null) {
                    setShowNDA(true);
                  } else if (isNDAAccepted === "Y") {
                    navigate("/bid");
                  }
                } else {
                  navigate("/bid");
                }
              }
            }
          } else {
            const isPhoneVerified = res?.data?.data;
            if (!isPhoneVerified) {
              dispatch(
                showOtpModal({
                  phoneNumber: profileInfo?.primaryPhone,
                  redirectScreen: "PDP",
                  redirectionRequired: true,
                })
              );
              dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
            }
          }
        } else {
          dispatch(setRedirectionAction('handlePlaceBid'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
        }
      } else {
        dispatch(setRedirectionAction('handlePlaceBid'));
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
        dispatch(setShowSessionMsg(false))
      }
    } catch (error) {
    } finally {
      setIsVerificationGoing(false);
    }
  };

  const navigateToPlaceBackUpOffer = async (listingId) => {
    // validateOfferMinMaxPriceError();

    // if (!offerAmount) {
    //   setvalidationError("Enter offer amount");
    //   return;
    // }
    // if (!(validationError)) {
    try {
      setIsVerificationGoing(true);
      if (profileInfo?.userEmailId) {

        const isSessionValid = await isValidSession();
        const isValid = isSessionValid.data?.isValidSession;

        const phoneNo = profileInfo?.primaryPhone;


        if (isValid === "Y") {
          trackButtonClick({
            eventName: "place_backup_offer_click",
            eventCategory: "NEW-PDP",
            eventSource: "on place backup offer click",
            eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
          });

          const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
          setIsVerificationGoing(false);

          if (res?.data?.data) {
            // if (!offerAmount) {
            //   return;
            // }
            //  if(!(validationError)){
            let offerType = "PLACE_BACKUP_OFFER";

            validateUserAction(offerType, listingId);

            // let offerType = "PLACE_BACKUP_OFFER"
            // const state = { listingId, userId: user.user.realbidUserId, offerAmount: offerCenterDetail?.listingPrice, offerType }
            // navigate("/offer", {
            //   state: state,
            // });
          } else {
            const isPhoneVerified = res?.data?.data;

            const data = { phoneNo, verificationType: "sms" };


            if (!isPhoneVerified) {
              dispatch(
                showOtpModal({
                  phoneNumber: profileInfo?.primaryPhone,
                  redirectScreen: "PDP",
                })
              );
              dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
              const response = await sendVerificationCode(data);

              if (
                response?.status === "FAILURE" &&
                response?.errorCode.startsWith("Invalid")
              ) {
              }
            }
          }
        } else {
          dispatch(setRedirectionAction('placeBackUpOffer'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
          // dispatch(setLoginCallback(() => navigateToPlaceBackUpOffer));

        }
      } else {
        dispatch(setRedirectionAction('placeBackUpOffer'));
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
        dispatch(setShowSessionMsg(false))
      }
    } catch (error) {
    } finally {
      setIsVerificationGoing(false);
    }
    // }
  };
  const handleRequestInformation = () => { };

  const validateUserAction = async (offerType, listingId) => {
    const listingid = pdpInitData?.listingDetail?.businessListingId;
    const type = offerType === "PLACE_BACKUP_OFFER" ? "Place Backup Offer" : "Place Offer"
    // const offerListingId = offerCenterDetail?.listingId;

    trackButtonClick({
      eventName: "user_action_type_check",
      eventCategory: "NEW-PDP",
      eventSource: `on ${type} click`,
      eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
      eventParams: { action_type: type }
    })

    const response = await getUserAction(listingid);
    trackApiCall({
      eventName: "user_action_type_check_success",
      eventCategory: "NEW-PDP",
      eventSource: `on ${type} click`,
      eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
      eventParams: { action_type: type }
    })

    if (response === true) {
      setAlertTitle(statusPayload?.hasHnb === 'Y' ? 'Place HnB Offer' : 'Place Counter Offer');
      setShowOfferAlert(true);
    } else {
      if (offerType === "PLACE_OFFER") {
        const state = { listingId, userId: user.user.realbidUserId, offerAmount: redirectionAmount, offerType }
        dispatch(setOfferData(state))
        navigate("/offer", {
          state: state,
        });


      } else {
        const state = { listingId, userId: user.user.realbidUserId, offerAmount: offerCenterDetail?.listingPrice, offerType }
        dispatch(setOfferData(state))
        navigate("/offer", {
          state: state,
        });

      }
      dispatch(setRedirectionAmount(''));
    }
  };
  const placeOffer = async (listingId) => {
    validateOfferMinMaxPriceError();
    if (!redirectionAmount) {
      setvalidationError("Enter offer amount");
       dispatch(setPdpError("Enter offer amount"))
      return;
    }
    if (!(validationError)) {
      try {
        setIsVerificationGoing(true);
        if (profileInfo?.userEmailId) {
          const isSessionValid = await isValidSession();
          const isValid = isSessionValid.data?.isValidSession;

          const phoneNo = profileInfo?.primaryPhone;

          if (isValid === "Y") {
            trackButtonClick({
              eventName: "place_offer_click",
              eventCategory: "NEW-PDP",
              eventSource: "on place offer click",
              eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
            });

            const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
            setIsVerificationGoing(false);

            if (res?.data?.data) {

              let offerType = "PLACE_OFFER"

              validateUserAction(offerType, listingId);

              // let offerType = "PLACE_OFFER"

              // const state = { listingId, userId: user.user.realbidUserId, offerAmount: offerAmount, offerType }
              // navigate("/offer", {
              //   state: state,
              // });

            } else {
              const isPhoneVerified = res?.data?.data;
              const data = { phoneNo, verificationType: "sms" }
              if (!isPhoneVerified) {
                dispatch(
                  showOtpModal({
                    phoneNumber: profileInfo?.primaryPhone,
                    redirectScreen: "PDP",
                  })
                );
                dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
                const response = await sendVerificationCode(data);

                if (
                  response?.status === "FAILURE" &&
                  response?.errorCode.startsWith("Invalid")
                ) {
                }
              }
            }
          } else {
            dispatch(setLoginModal(true));
            dispatch(setLoginTab("loginTab"));
            dispatch(setLoginCallLocation("Popup"));
            dispatch(setShowSessionMsg(true))
          }
        } else {
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(false))
        }
      } catch (error) {
      } finally {
        setIsVerificationGoing(false);
      }
    }
  };
    useEffect(()=>{
   if (!bidAmount || parseInt(bidAmount) < parseInt(auctionDetails?.nextpossibleBidAmount)) {
          setBidAmount(auctionDetails?.nextpossibleBidAmount);
        }
      },[auctionDetails])

  const validateOfferMinMaxPriceError = (value) => {
    if (!redirectionAmount) {
      setvalidationError(`Enter offer amount`);
      dispatch(setPdpError(`Enter offer amount`));
    } else if (redirectionAmount < offerMinLimit) {
      setvalidationError(`Amount should be greater than $${getFormatPrice(offerMinLimit)}`);
      dispatch(setPdpError(`Amount should be greater than $${getFormatPrice(offerMinLimit)}`));
    } else if (redirectionAmount > offerMaxLimit) {
      setvalidationError(`Amount should be less than $${getFormattedPrice(offerMaxLimit)}`);
      dispatch(setPdpError(`Amount should be less than $${getFormattedPrice(offerMaxLimit)}`));
    } else {
      setvalidationError("");
      dispatch(setPdpError(""));
    }
  };

  const handleOfferAmountChange = (e) => {
    const text = e.target.value;

    if (text) {
      var amnt = text?.replace("$", "");
      // setOfferAmount(amnt?.toString().replace(/,/g, ""));
      dispatch(setRedirectionAmount(amnt?.toString().replace(/,/g, "")));
    }
    setvalidationError("");
    dispatch(setPdpError(""))
  };
  const handleBidAmountChange = (e) => {
    const text = e.target.value;
    if (text === "") {
      setBidAmount("");
    } else {
      var amnt = text.replace("$", "");
      setBidAmount(amnt?.toString().replace(/,/g, ""));
    }
    setvalidationError("");
    dispatch(setPdpError(""))
  };
  const renderBidCenterForActiveAuction = () => {
    return (
      <div className="listing_list_style mt0 align-items-center">
        <div className="list-inline-item right-bar">
          <p className={`time-left-txt`} tabIndex="0">Time left</p>
          <p className={`listing-time ${isLastFewMins ? "time-left-last" : ""}`} tabIndex="0">{`${timeLeft <= 10 ? '0' : ''}${timeLeft} ${timeLeftUnit}`}</p>
        </div>
        <div className="list-inline-item pr10">
          <p className="time-left-txt" tabIndex="0">{priceLabel}</p>
          <p className="listing-time" tabIndex="0">{priceAmount}</p>
        </div>
        <div className="list-inline-item bidAmountContainerHeader vl-top">
          <button
            className="left-btn"
            type="link"
            onClick={decrement}
            aria-label="decrement"
          >
            <FaMinus />
          </button>
          <input
            className="bid-amount-input-header"
            type="text"
            value={"$" + getFormattedPrice(bidAmount)}
            onChange={handleBidAmountChange}
            maxLength={bidMaxLength}
            aria-label="Bid amount"
            onBlur={() => {
              validateBidMinMaxPriceError();
            }}
          />
          <button
            className="bidAmountBtnHeader pl0"
            type=""
            data-bs-toggle=""
            aria-label="increment"
            onClick={increment}
          >
            <FaPlus />
          </button>
          {validationError ? (
            <p style={{ color: "red", fontSize: 12, paddingTop: 5, position: 'absolute', width: 'max-content'}}>
              {validationError}
            </p>
          ) : null}
        </div>
        <button
          className="list-inline-item btn btn-thm center bidAmount-header-btn vl-top"
          onClick={() => hanldePlaceBid("placeBid")}
        >
          {isVerificationGoing ? <LoadingText text="Processing..." /> : <LoadedText text="Place Bid" />}
        </button>
        {offerType !== "PLACE_OFFER" && offerType !== "PLACE_BACKUP_OFFER" && offerType !== "WATCH_PROPERTY" &&
          !isWatchProperty && !bidCenterData.bestBidAvailable &&
          !bidCenterData?.sellerFinalNegotiationResponse?.sellerFinalNegotiationAvailable &&
          (isUnderReviewAuction || isUnderContractAuction || statusPayload.hasHnb === "Y") && (
            <button
              className="btn btn-thm-bidCenter center col-12 p-2 vl-top"
              type=""
              onClick={() => hanldePlaceBid("placeBackupBid")}
            >
              {!statusPayload.isTraditional && "Place Backup Bid"}
            </button>
          )}
        {ownItNowEnabled &&
          bidCenterData?.ownitNowPrice !== "" &&
          bidCenterData?.ownitNowPrice !== 0 &&
          bidCenterData?.ownitNowPrice !== null &&
          bidCenterData?.ownitNowPrice !== "-" &&
          auctionDetails?.auctionTimeLeft !== null &&
          auctionDetails?.auctionTimeLeft > 900 &&(
            <>
              <div className="list-inline-item mt15 vl-top" style={{marginTop:15}}>
                <p>Or</p>
              </div>
              <button
                className="list-inline-item btn btn-thm end-auction-btn vl-top"
                type=""
                onClick={() =>
                  handleOwnItNow()
                }
              >
                {isVerificationGoingForOwnitNow ? <LoadingText text="Processing..." /> : <LoadedText text={`End the Auction Now  $${getFormatPrice(bidCenterData?.ownitNowPrice)}`} />}

                {/* End the Auction Now  {"$" + getFormatPrice(bidCenterData?.ownitNowPrice)} */}
              </button>
            </>
          )}
      </div>
    );
  };
  const placeBackupOfferHeader = () => {
    return (
      <div className="listing_list_style mt0 align-items-center">
        {/* <div className="list-inline-item right-bar">
          <p className="time-left-txt"></p>
          <p className="listing-time"></p>
        </div> */}
        <div className="list-inline-item pr10">
          <p className="time-left-txt" tabIndex="0">{priceLabel}</p>
          <p className="listing-time" tabIndex="0">{priceAmount}</p>
        </div>
        <div className="list-inline-item bidAmountContainerHeader vl-top">
          <input
            className="offer-amount-custom"
            tabIndex="0"
            style={{
              border: "none",
            }}
            type=""
            id=""
            value={
              redirectionAmount ? "$" + getFormattedPrice(redirectionAmount) : ""
            }
            onChange={handleOfferAmountChange}
            placeholder="Enter Your Offer"
            onBlur={() => {
              validateOfferMinMaxPriceError();
            }}
          />
          {validationError ? (
            <p style={{ color: "red", fontSize: 12, paddingTop: 5, position: 'absolute', width: 'max-content'}}>
              {validationError}
            </p>
          ) : null}
        </div>
        <button
          className="list-inline-item btn btn-thm center bidAmount-header-btn vl-top"
          type=""
          onClick={() => placeOffer(offerCenterDetail?.listingId)}
        >
          {isVerificationGoing ? <LoadingText text="Processing..." /> : <LoadedText text="Place Offer" />}
        </button>
        {offerType !== "PLACE_OFFER" && offerType !== "PLACE_BACKUP_OFFER" && offerType !== "WATCH_PROPERTY" &&
          !isWatchProperty && !bidCenterData.bestBidAvailable &&
          !bidCenterData?.sellerFinalNegotiationResponse?.sellerFinalNegotiationAvailable &&
          (isUnderReviewAuction || isUnderContractAuction || statusPayload.hasHnb === "Y") && (
            <button
              className="btn btn-thm-bidCenter center col-12 p-2"
              type=""
              onClick={() => hanldePlaceBid("placeBackupBid")}
            >
              {!statusPayload.isTraditional && "Place Backup Bid"}
            </button>
          )}
        {ownItNowEnabled &&
          bidCenterData?.ownitNowPrice !== "" &&
          bidCenterData?.ownitNowPrice !== 0 &&
          bidCenterData?.ownitNowPrice !== null &&
          bidCenterData?.ownitNowPrice !== "-" && (
            <>
              <div className="list-inline-item">
                <p>Or</p>
              </div>
              <button
                className="list-inline-item btn btn-thm end-auction-btn"
                type=""
                onClick={() =>
                  handleOwnItNow()
                }
              >
                {isVerificationGoingForOwnitNow ? <LoadingText text="Processing..." /> : <LoadedText text={`End the Auction Now  $${getFormatPrice(bidCenterData?.ownitNowPrice)}`} />}

                {/* End the Auction Now  {"$" + getFormatPrice(bidCenterData?.ownitNowPrice)} */}
              </button>
            </>
          )}
      </div>
    );
  };

  const renderBidCenterForWFAAuction = () => {
    return (
      <div className="p30" style={{ height: "auto" }}>
        <h2
          className="text-center pb20 bidCenterSubtitleHeading"
          style={{ marginTop: 0 }}
        >
          {getData().header?.toUpperCase()}
        </h2>

        <Col
          xs={12}
          md={12}
          className="d-flex  col justify-content-between align-items-center "
        >
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            Approximate Start Date
          </p>
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            {bidCenterData?.dateFormattedListingStartDate}{" "}
          </p>
        </Col>

        <Col
          xs={12}
          md={12}
          className="d-flex  col justify-content-between align-items-center"
        >
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            Approximate Start Time
          </p>
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            {bidCenterData?.timeFormattedListingStartTime}{" "}
          </p>
        </Col>

        <Col
          xs={12}
          md={12}
          className="d-flex  col justify-content-between align-items-center pb20"
        >
          <p xs={6} md={6} className="pdpBody3">
            {" "}
            Starting Bid:
          </p>
          <p xs={6} md={6} className="pdpBody3">
            {getPrice().amount}{" "}
          </p>
        </Col>

        <button
          className="btn btn-thm center col-12"
          type=""
          onClick={() =>
            saveProperty()
          }
        >
          Save This Property
        </button>
      </div>
    );
  };
  const renderBidCenterForWLST = () => {
    return (
      <div className="">
        <h1 className="text-center">Bid Center</h1>
        <Row className="d-flex justify-content-between align-items-center">
          <p className="text-center">
            This listing is currently unavailable.
            <a
              href=""
              rel="noopener noreferrer"
              style={{ color: "#349beb", marginLeft: "5px" }}
            >
              Click here{" "}
            </a>
            to browse properties nearby.
          </p>
        </Row>
      </div>
    );
  };
  const renderBidCenter = () => {
    return (
      <div className="prpl20 pt20 pb20">
        {listingType === "TRNL" || listingType === null ? (
          <h3 center style={{ margin: 10 }} className="bid-heading-ends">
            {getData().header}
          </h3>
        ) : (
          getHeader()
        )}

        {listingType === "TRNL" || listingType === null ? (
          <p
            size={15}
            lh={22}
            color={"black"}
            style={{ marginLeft: 10, marginRight: 10, marginBottom: 10 }}
          >
            {getData().content}
          </p>
        ) : (
          getContent()
        )}
        {showBid && !isPreviewProperty && (propCategory !== 'COMMERCIAL') && (
          <Col
            xs={12}
            md={12}
            className="prpl20 col d-flex justify-content-between align-items-center"
          >
            <p
              xs={6}
              md={6}
              className="text-left tdu pdp-bid-deposit-data"
              data-tooltip-id="bidDepositToolTip"
              data-tooltip-content="A Bid Deposit authorization hold is required in order to place bids on a property. The Bid Deposit is a one-time hold authorized by you on your credit card prior to placing a bid. The actual value of the hold will be confirmed before placing the bid. On each applicable property, the buyer (or agent on buyer's behalf) will be required to authorize the hold on a credit card prior to placing a bid. If, after the end of the auction, you are the selected bidder (i.e. the bidder chosen by the seller to proceed with the purchase), then the hold will remain in place until we receive payment confirmation of the earnest money deposit. If you are not the selected bidder, the bid deposit hold will be released. For more details, please visit our FAQ's."
            >
              Bid Deposit:
              <Tooltip id="bidDepositToolTip" style={{ width: 300 }} />
            </p>
            <p xs={6} md={6} className="text-right pdp-bid-deposit-value">
              Required
            </p>
          </Col>
        )}

        {!isPreview && (propCategory !== 'COMMERCIAL') && (
          <Col
            xs={12}
            md={12}
            className="d-flex prpl20 pt10 col justify-content-between align-items-center"
          >
            <p
              xs={6}
              md={6}
              className="text-left tdu pdp-bid-deposit-data"
              data-tooltip-id="cashOnlyToolTip"
              data-tooltip-content="The Seller will consider conventional financing and cash offers."
            >
              Cash Only:
            </p>
            <p xs={6} md={6} className="text-left pdp-bid-deposit-value">
              {" "}
              {isCashOnly ? " Yes" : " No"}{" "}
            </p>
            <Tooltip id="cashOnlyToolTip" />
          </Col>
        )}
        {isPreview && (
          <div style={{ marginTop: 20, marginBottom: 10 }}>
            {/* <button onPress={onSave}> */}
            <h1 active>
              {isSaved ? "Remove This Property" : "Save This Property"}
            </h1>
            {/* </button> */}
          </div>
        )}
        <div>
          {(bidCenterData.bestBidAvailable ||
            bidCenterData?.sellerFinalNegotiationResponse
              ?.sellerFinalNegotiationAvailable) && (
              <div className="pt30">
                <button
                  className="btn btn-thm center col-12"
                  type=""
                  onClick={navigateToPlaceBackUpBid}
                >
                  {bidCenterData.bestBidAvailable && isSignedUser
                    ? "Place Best Bid"
                    : bidCenterData?.sellerFinalNegotiationResponse
                      ?.sellerFinalNegotiationAvailable
                      ? "Confirm Offer for $" +
                      getFormattedPrice(
                        bidCenterData?.sellerFinalNegotiationResponse
                          ?.solicitationAmount
                      )
                      : ""}
                  {/* <input
                  type="button"
                  value="demobutton"
                  // style={{ backgroundColor: "var(--color-primary)" }}
                  onClick={place_BestBid}
                /> */}
                </button>
                <PlaceBestBidModal
                  show={showBestBidModal}
                  onHide={() => setShowBestBidModal(false)}
                  listingId={pdpInitData?.listingDetail?.listingId}
                // onSubmit={handleBestBidSubmit}
                />
              </div>
            )}

          {(isWatchProperty || statusPayload.isUpcoming) && (
            <div>
              <button onPress={isSaved ? gotoFavourite : onSave}>
                {isSaved ? "Go to Favorites" : "Add To Favorites"}
              </button>
            </div>
          )}
          {/*{status.isActive && !status.hasHnb === 'Y' && (*/}
          {statusPayload.isActive &&
            !isWatchProperty &&
            offerType !== "PLACE_BACKUP_OFFER" && (
              <div>
                <div>
                  {!statusPayload?.isTraditional && (
                    <>
                      <div>
                        <button onPress={isSaved ? gotoFavourite : onSave}>
                          Add To Favorites
                        </button>
                      </div>
                    </>
                  )}
                  {statusPayload.isTraditional &&
                    offerType !== "PLACE_OFFER" &&
                    offerType !== "WATCH_PROPERTY" && <></>}
                  {statusPayload.isTraditional &&
                    offerType === "PLACE_OFFER" && <></>}
                  {offerType !== "WATCH_PROPERTY" && <></>}
                </div>
                {ownItNowEnabled &&
                  bidCenterData?.ownItNowPrice !== "" &&
                  bidCenterData?.ownItNowPrice !== 0 &&
                  bidCenterData?.ownItNowPrice !== null &&
                  bidCenterData?.ownItNowPrice !== "-" && (
                    <>
                      <div containerWidth={fullWidth}>
                        <div />
                        <p>or</p>
                        <div />
                      </div>
                      <div>
                        <button
                        // onPress={() => {
                        //   setOwnitNowClicked(true);
                        //   validateandContinue();
                        //   dispatch(updateIsOwnitnow(true));
                        // }}
                        >
                          <button active>
                            <h1 active ownitnow>
                              End the Auction Now
                            </h1>
                          </button>
                        </button>
                        <p>For ${getFormattedPrice(p)}</p>
                      </div>
                    </>
                  )}
                <p>
                  {bidCenterData?.ownItNowPrice ? (
                    <p>{bidCenterData?.ownItNowPrice}</p>
                  ) : null}
                </p>
              </div>
            )}
          {offerType !== "PLACE_OFFER" &&
            offerType !== "PLACE_BACKUP_OFFER" &&
            offerType !== "WATCH_PROPERTY" &&
            !isWatchProperty &&
            !bidCenterData.bestBidAvailable &&
            !bidCenterData?.sellerFinalNegotiationResponse
              ?.sellerFinalNegotiationAvailable &&
            (isUnderReviewAuction ||
              isUnderContractAuction ||
              statusPayload.hasHnb === "Y") &&
            latestBidCenterData.placeBackupBidButton === true && (
              <div className="pt20">
                <button
                  className="btn btn-thm center col-12 p-2"
                  type=""
                  onClick={() =>
                    hanldePlaceBid("placeBackupBid")
                  }
                >
                  {!statusPayload.isTraditional && "Place Backup Bid"}
                </button>
              </div>
              // </button>
            )}
          {offerType !== "PLACE_OFFER" &&
            !isWatchProperty &&
            statusPayload.isPreview && (
              //   <button onPress={isSaved ? gotoFavourite : onSave}>
              <div>
                <button
                  className="btn btn-thm center col-12"
                  type=""
                  onClick={saveTofav}
                >
                  {isSaved ? "Go to Favorites" : "Add To Favorites"}
                </button>
              </div>
              //   </button>
            )}
          {propCategory === "NPL" && (
            //   <button onPress={() => navigateToLeadForm()}>
            <div>
              <button
                className="btn btn-thm center col-12"
                type=""
                onClick={handleRequestInformation}
              >
                Request Information
              </button>
            </div>
            //   </button>
          )}
          {offerType === "PLACE_BACKUP_OFFER" &&
            statusPayload.isTraditional && (
              //   <button onPress={() => navigateToPlaceBackUpOffer()}>
              <div>
                <button
                  className="btn btn-thm center col-12"
                  type=""
                  onClick={() =>
                    navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)
                  }
                >
                  Place Backup Offer
                </button>
              </div>
              //   </button>
            )}

          {countyBiddingEnabled === "Y" && (
            //   <button onPress={() => navigateToBidCountySite()}>
            <div>
              <button
                className="btn btn-thm center col-12"
                type=""
                onClick={navigateToBidCountySite}
              >
                Bid on County Site
              </button>
            </div>
            //   </button>
          )}
        </div>
      </div>
    );
  };
  // <div>

  const renderForeclosureView = () => {
    return (
      <ForeclosureView
        eventCenterDetail={pdpInitData?.eventCenterDetail}
        statusPayload={statusPayload}
        estimatedOpeningBid={
          pdpInitData?.propertyDetails?.detailedAttributes?.estimatedOpeningBid
        }
        propCategory={commonAttributes?.propCategory}
        status={commonAttributes?.status}
      />
    );
  };

  const renderBidCenterForCommercial = () => {
    return (
      <div style={{ height: "auto" }}>
        {listingType === "AUCN" && (
          <>
            {bidCenterData?.auctionTimeLeft !== null &&
              bidCenterData?.auctionTimeLeft > 900 && (
                <div>
                  <div className="bid-center-header">
                    <h3 className="text-center bid-heading-ends">Auction Begins In</h3>
                    <div className="d-flex justify-content-center">
                      <CountdownTimer
                        shouldShowLabel={false}
                        until={latestBidCenterData?.auctionTimeLeft}
                      />
                    </div>
                  </div>
                  <div className="prpl20 pt25">
                    <h3 className="text-center bid-heading-ends-offer" style={{ width: "auto" }}>
                      {getPrice().amount}
                    </h3>
                    <p className="text-center bid-heading-ends-label" style={{ width: "auto" }}>
                      {getPrice().label}
                    </p>
                  </div>
                </div>
              )}
          </>
        )}
        <div className="mx-3 mt-4">
          <button
            className="btn btn-thm center col-12 p-2 mb-4"
            type=""
            onClick={() =>
              hanldePlaceBid(pdpInitData?.cifCompleted
                ? "registerCompleted"
                : "registerToBid")
            }
          >
            {pdpInitData?.cifCompleted
              ? "Registration Completed"
              : "Register to Bid"}
          </button>

        </div>
      </div>
    );
  };

  const renderPreviewBidCenter = () => {
    return (
      <div className="prpl20">
        <h2 className="text-center preview-title pt25 pb10">PREVIEW PROPERTIES</h2>

        <div>
          <p className="text-left preview-data" style={{ width: "auto" }}>
            Stay ahead of the market with Hubzu's Preview Properties. Find out
            what properties are scheduled to come to our site, keep track of the
            perfect home and prepare to make a bid or offer.
          </p>
        </div>

        <button
          className="btn btn-thm center col-12 mb15 p-2 semi-bold"
          type=""
          onClick={() =>
            hanldePlaceBid()
          }
        >
          {pdpInitData?.onWatchList
            ? "Remove This Property"
            : "Save This Property"}
        </button>
      </div>
    );
  };

  const renderOfferDetails = () => {
    return (
      <div className="prpl20 pt20 pb20">
        {
          offerType === "PLACE_OFFER" && statusPayload.isTraditional && (
            <>
              <h3 className="text-center bid-heading-ends-offer" style={{ width: "auto" }}>
                {getPrice().amount}
              </h3>
              <p className="text-center bid-heading-ends-offer-label" style={{ width: "auto" }}>
                {getPrice().label}
              </p>

            </>
          )
        }
        {
          offerType === "PLACE_BACKUP_OFFER" && statusPayload.isTraditional && (
            <>
              <h3 className="bid-heading-ends">
                HIGHEST & BEST PERIOD ENDED

              </h3>
              {getContent()}
            </>
          )
        }
        {/* {
          offerType === "PLACE_BACKUP_OFFER" && statusPayload.isTraditional && (
            <Col
              xs={12}
              md={12}
              className="prpl20 col d-flex justify-content-between align-items-center"
            >
              <p xs={6} md={6} className="text-left fwb tdu pdp-bid-deposit-data mt10">
                Listing Price:
                <Tooltip id="bidDepositToolTip" style={{ width: 300 }} />
              </p>
              <p xs={6} md={6} className="text-right  pdp-bid-deposit-value">
                {getFormatPrice(offerCenterDetail?.listingPrice)}
              </p>
            </Col>

          )
        } */}

        {!isPreview  && (propCategory !== 'COMMERCIAL') && (
          <Col
            xs={12}
            md={12}
            className="d-flex prpl20  col justify-content-between align-items-center"
          >
            <p
              xs={6}
              md={6}
              className="text-left tdu  pdp-bid-deposit-data pt10"
              data-tooltip-id="cashOnlyToolTip"
              data-tooltip-content="The Seller will consider conventional financing and cash offers."
            >
              Cash Only:
            </p>
            <p xs={6} md={6} className="text-left  pdp-bid-deposit-value">
              {" "}
              {isCashOnly ? " Yes" : " No"}{" "}
            </p>
            <Tooltip id="cashOnlyToolTip" />
          </Col>
        )}

        {statusPayload.isTraditional && offerType === "PLACE_OFFER" && (
          <Row xs={12} md={12} className="mt10">
            <Col xs={12} md={7} className="">
              <div className="bidAmountContainer">
                <input
                  className="col-md-12"
                  style={{
                    padding: 0,
                    border: "none",
                    background: "none",
                    textAlign: "center",
                    height: "45px"
                  }}
                  type=""
                  id=""
                  value={redirectionAmount ? "$" + getFormattedPrice(redirectionAmount) : ""}
                  onChange={handleOfferAmountChange}
                  placeholder="Enter your amount"
                  // maxLength={bidMaxLength}
                  onBlur={() => {
                    validateOfferMinMaxPriceError();
                  }}
                />

              </div>
              {validationError ? (
                <p style={{ color: "red", fontSize: 12, paddingTop: 5 }}>
                  {validationError}
                </p>
              ) : null}
            </Col>

            <Col xs={12} md={5}>
              <button
                className="btn btn-thm center col-12 p-2"
                type=""
                onClick={() => placeOffer(offerCenterDetail?.listingId)}
              >
                Place Offer
              </button>
            </Col>
          </Row>
        )}
        {offerType === "PLACE_BACKUP_OFFER" && statusPayload.isTraditional && (
          //   <button onPress={() => navigateToPlaceBackUpOffer()}>
          <div>
            <button
              className="btn btn-thm center col-12 p-2 mt10"
              type=""
              onClick={() =>
                navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)
              }
            >
              Place Backup Offer
            </button>
          </div>
          //   </button>
        )}
      </div>
    );
  };


  const renderViews = () => {
    if (
      isForeclosure &&
      (commonAttributes?.status === "SCHEDULED" ||
        commonAttributes?.status === "AUCTION_EVENT_ENDED" ||
        commonAttributes?.status === "CLEAR_TO_SALE") &&
      pdpInitData?.eventCenterDetail &&
      pdpInitData?.fcOnlineFlag !== "Y" &&
      !pdpInitData?.fcProxyBidEnabled
    ) {
      // return renderForeclosureView();
    }
    if (listingType === "AUCN") {
      if (statusPayload.isActiveAuction === true) {
        return renderBidCenterForActiveAuction();
      } else if (status === "WFA") {
        // return renderBidCenterForWFAAuction();
      } else if (status === "PACT") {
        // return renderBidCenterForCommercial();
      } else {
        // return renderBidCenter();
      }
      return null;
    } else if (listingType === "TRNL") {
      // return renderOfferDetails();
    } else {
      if (listingType === null) {
        if (isPreview) {
          // return renderPreviewBidCenter();
        }
        // return renderBidCenterForWLST();
      } else {

        // return renderBidCenter();
      }

    }
  }
  const handleClose = () => {
    setShowAlert(false);
    setShowOfferAlert(false);
  }
  const handleNDAccepted = () => {
    setShowNDA(false);
    navigate("/bid");
  };
  const handleNDAClose = () => {
    setShowNDA(false);
  }


  const handleNavigatioToMyOffer = () => {
    navigate('/my-shopper/myOffers')
  }
  return (
    <div className="list-inline-item">
      {isAllowedPreSale ? "" : propCategory === "NPL" ? (
        <button
          className="list-inline-item btn btn-thm center bidAmount-header-btn"
          onClick={handleRequestInformation}
        >
          Request Information
        </button>
      ) : pdpInitData?.fcProxyBidEnabled === "true" && status != "AUCTION_EVENT_ENDED" ? (
        <>
          {pdpInitData?.eventCenterDetail?.estimatedOpeningBidAmount !== 0 && (
            <div className="list-inline-item pr10">
              <p className="time-left-txt">Estimated Opening Bid</p>
              <p className="listing-time">{pdpInitData?.eventCenterDetail?.estimatedOpeningBidAmount}</p>
            </div>
          )}
          {pdpInitData?.userRegisteredForFcProxyBid === "true" ? (
            <button
              className="list-inline-item btn btn-thm center bidAmount-header-btn"
              onClick={() => { }}
            >
              Place Proxy Bid
            </button>
          ) : (
            <button
              className="list-inline-item btn btn-thm center bidAmount-header-btn"
              onClick={() => { }}
            >
              Register to Proxy Bid
            </button>
          )}
        </>
      ) : listingType == "AUCN" && status == "ACTV" ? (
        renderBidCenterForActiveAuction()
      ) : offerType === "PLACE_OFFER" && status == "ACTV" ? (
        placeBackupOfferHeader()
      ) : offerCenterDetail && (status == "ACTV" || status == "SPND") ? (
        offerType === "PLACE_BACKUP_OFFER" && (
          <button
            className="list-inline-item btn btn-thm center bidAmount-header-btn"
            onClick={() => navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)}
          >
            Place Backup Offer
          </button>
        )
      ) : (<></>)}
      <BidAlertTextModal showAlert={showAlert} onClose={handleClose} alertText={alertText} />
      <Modal show={showOfferAlert} onHide={handleClose}>
        <Modal.Header closeButton className="license-title">
          <Modal.Title className="text-white roboreg">
            {alertTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="p-4 text-center roboreg">
            A seller counter/HnB is already placed, please place the Counter/HnB from My Offers
          </p>
          <div className="d-flex justify-content-center">
            <button className="no-btn" onClick={() => handleNavigatioToMyOffer()}>My Offers</button>
            <button className="no-btn" onClick={() => handleClose()}>Cancel</button>
          </div>
        </Modal.Body>
      </Modal>
      {
        showNDA &&
      <NDAModel
        show={showNDA}
        handleClose={handleNDAClose}
        handleNDAccept={handleNDAccepted}
        userProfileData={profileInfo} />
      }
    </div>
  );
};

export default BidCenterHeader;
